exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".explain[data-v-579bd95e]{height:5.33333vw;line-height:5.33333vw;font-size:3.73333vw;color:#333;text-align:center;margin-top:1.33333vw}.explain .square[data-v-579bd95e]{display:inline-block;vertical-align:middle;width:2.66667vw;height:2.66667vw;border-radius:.8vw;background-color:#3f8eff;margin-right:2.66667vw}", ""]);

// exports
